import { FC } from 'react';
import { useState, useEffect } from 'react';
import { useFragment, graphql, Environment } from 'react-relay';

import { addForceFavoriteRefetchHandler } from 'dibs-buyer-layout/exports/loginHandlers';
import { locations } from '../../../utils/tracking/shared/favoritesTracking';

import { FavoritesItem } from '../../../components/global/FavoriteIcons/FavoritesItem';
import { FavoritesProvider } from '../../../components/global/FavoriteIcons/FavoritesProvider';

import { PdpSharedSidebarFavorites_item$key } from './__generated__/PdpSharedSidebarFavorites_item.graphql';

import styles from './PdpSharedSidebarFavorites.scss';

export const PdpSharedSidebarFavorites: FC<{
    environment: Environment;
    item: PdpSharedSidebarFavorites_item$key;
    isClient: boolean;
    userId?: string | null;
    showHeartCount?: boolean | null;
    onFavorited?: () => void;
    itemImage?: string;
    wrapperClass?: string;
    heartIconWrapperClass?: string;
    folderIconWrapperClass?: string;
}> = ({
    environment,
    item: itemRef,
    isClient,
    userId,
    showHeartCount,
    onFavorited,
    itemImage,
    wrapperClass,
    heartIconWrapperClass,
    folderIconWrapperClass,
}) => {
    const item = useFragment(
        graphql`
            fragment PdpSharedSidebarFavorites_item on Item {
                ...FavoritesItem_item
                serviceId
                isAuctionEnabled
            }
        `,
        itemRef
    );
    const [shouldFavoritesProviderRefetch, setShouldFavoritesProviderRefetch] = useState(false);

    useEffect(() => {
        addForceFavoriteRefetchHandler(() => {
            setShouldFavoritesProviderRefetch(true);
        });
    }, [setShouldFavoritesProviderRefetch]);

    return (
        <FavoritesProvider
            environment={environment}
            location={item?.isAuctionEnabled ? locations.AUCTION_PDP : locations.SIDEBAR}
            disable={!isClient}
            userId={userId}
            itemIds={[item?.serviceId]}
            shouldAutoFavorite
            shouldRefetch={shouldFavoritesProviderRefetch}
            shouldShowHeartCount={showHeartCount}
        >
            {({ props: renderProps }: $TSFixMe) => (
                <FavoritesItem
                    {...renderProps}
                    fetchFolder={renderProps?.fetchFolder}
                    item={item}
                    itemImage={itemImage}
                    wrapperClass={wrapperClass}
                    heartIconWrapperClass={heartIconWrapperClass}
                    folderIconWrapperClass={folderIconWrapperClass}
                    animateHeartPulse
                    heartIconClass={styles.icon}
                    folderIconClass={styles.icon}
                    onFavorited={onFavorited}
                />
            )}
        </FavoritesProvider>
    );
};
